import { render, staticRenderFns } from "./BaseTableGroup.vue?vue&type=template&id=02a293e0&functional=true&"
import script from "./BaseTableGroup.vue?vue&type=script&lang=js&"
export * from "./BaseTableGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports